<template>
    <div class="content3d--area relative" style="z-index:2; overflow:hidden;">
        <div class="b-container relative" style="padding-top:60px; padding-bottom:60px;">
            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="h1 ml-xxl">合作客户</div>
                    <div class="relative ml-md" style="width:44px; height:44px;">
                        <img :src="PlusRedIcon" style="width:44px; height:44px; position:absolute; top:-12px; left:0;" />
                    </div>
                </div>
                <div class="t3 secondary" style="text-transform: uppercase; letter-spacing:.1em;">
                    corporate clients
                </div>
            </div>
            <div v-if="clientWidth >= 992">
                <div class="tab-list">
                    <div style="width: 33%;display: flex;align-items: center;justify-content: center;"
                        v-for="(item, index) in tabList" :key="index">
                        <div @click="changeTab(index)" :class="[choosed == item.id ? 'tab-item-choose' : 'tab-item']">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div style="background-color:#FBFBFD; padding-bottom: 20px;border-radius: 10px;padding-left: 10px;">
                    <div v-if="choosed == 0">
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList1" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList2" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                    </div>
                    <div v-if="choosed == 1">
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList4" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList5" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList6" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                    </div>
                    <div v-if="choosed == 2">
                        <div class="tab-list">
                            <div class="image-list" v-for="(img, indexImg) in imgList3" :key="indexImg">
                                <img :src="img" class="image-item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="oracle-bg">
                    <div style="position: absolute;width: 100%;height: 100%;">
                        <img :src="CompanyBg" style="width: 100%;height: 100%;" />
                    </div>
                    <div style="position: absolute;padding: 30px 60px;">
                        <div class="h3 mb-md" style="white-space: pre-wrap;">{{ oracleTitle }}</div>
                        <div class="h3 mb-md">Partner Oracle Cloud</div>
                        <div class="t5">Oracle Cloud
                            是首款从零开始打造的公有云技术解决方案，旨在成为更适合每种应用的云技术。杭州灵鹿与Oracle保持着紧密的合作伙伴关系，借助Oracle的混合云能力、云原生应用的建设能力等，杭州灵鹿为客户提供专业的云解决方案和优质的云服务。
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="tab-list">
                    <div style="width: 33%;display: flex;align-items: center;justify-content: center;"
                        v-for="(item, index) in tabList" :key="index">
                        <div @click="changeTab(index)"
                            :class="[choosed == item.id ? 'tab-item-choose-mobile' : 'tab-item-mobile']">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div style="background-color:#FBFBFD; padding-bottom: 20px;border-radius: 10px;padding-left: 10px;">
                    <div v-if="choosed == 0">
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList11" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList12" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList21" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                    </div>
                    <div v-if="choosed == 1">
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList41" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList42" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList51" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList52" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList61" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList62" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                    </div>
                    <div v-if="choosed == 2">
                        <div class="tab-list">
                            <div class="image-list-mobile" v-for="(img, indexImg) in imgList31" :key="indexImg">
                                <img :src="img" class="image-item-mobile" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="oracle-bg-min">
                    <div style="position: absolute;width: 100%;height: 100%;">
                        <img :src="CompanyBg" style="width: 100%;height: 100%;" />
                    </div>
                    <div style="position: absolute;padding: 15px 20px;">
                        <div class="h4 mb-md" style="white-space: pre-wrap;">{{ oracleTitle }}</div>
                        <div class="h4 mb-md">Partner Oracle Cloud</div>
                        <div class="t6">Oracle Cloud
                            是首款从零开始打造的公有云技术解决方案，旨在成为更适合每种应用的云技术。杭州灵鹿与Oracle保持着紧密的合作伙伴关系，借助Oracle的混合云能力、云原生应用的建设能力等，杭州灵鹿为客户提供专业的云解决方案和优质的云服务。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    PlusRedIcon, Company01, Company02, Company03, Company04, Company05, Company06,
    Company07, Company08, Company09, Company10, Company11, Company12,
    Company13, Company14, Company15, Company16, Company17, Company18,
    Company19, Company20, Company21, Company22, Company23, Company24,
    Company25, Company26, CompanyDefault, Company27, CompanyBg
} from '@/constants/pics';

export default {
    name: 'company',

    components: {},

    data() {
        return {
            oracleTitle: '合作伙伴\n甲骨文云',
            clientWidth: 0,
            PlusRedIcon, Company01, Company02, Company03, Company04, Company05, Company06,
            Company07, Company08, Company09, Company10, Company11, Company12,
            Company13, Company14, Company15, Company16, Company17, Company18,
            Company19, Company20, Company21, Company22, Company23, Company24,
            Company25, Company26, Company27, CompanyBg,
            choosed: 0,
            tabList: [{ name: '校园', id: 0 },
            { name: '商业', id: 1 },
            { name: '园区', id: 2 }],
            imgList1: [Company20, Company21, Company22, Company23, Company24, Company25],
            imgList2: [Company26, CompanyDefault, CompanyDefault, CompanyDefault, CompanyDefault, CompanyDefault],
            imgList3: [Company18, Company17, Company19, CompanyDefault, CompanyDefault, CompanyDefault],
            imgList4: [Company27, Company02, Company03, Company04, Company05, Company06],
            imgList5: [Company07, Company08, Company09, Company10, Company11, Company12],
            imgList6: [Company13, Company14, Company15, Company01, CompanyDefault, CompanyDefault],

            imgList11: [Company20, Company21, Company22],
            imgList12: [Company23, Company24, Company25],
            imgList21: [Company26, CompanyDefault, CompanyDefault],

            imgList31: [Company18, Company17, Company19],

            imgList41: [Company27, Company03, Company02],
            imgList42: [Company04, Company05, Company06],


            imgList51: [Company07, Company09, Company08],
            imgList52: [Company10, Company11, Company12],


            imgList61: [Company13, Company14, Company15],
            imgList62: [Company01, CompanyDefault, CompanyDefault],
        };
    },

    computed: {},

    created() {
        this.imgList = this.imgList1;
    },

    mounted() {  // 02
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {

                // 02
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        changeTab(i) {
            this.choosed = i;
            if (i == 1) {
                this.imgList = this.imgList2
            } else if (i == 2) {
                this.imgList = this.imgList3
            } else {
                this.imgList = this.imgList1
            }
        }
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.contact-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
}

.contact-wrap.display {
    display: block;
}

.contact-wrap.hide {
    display: none;
}

.contact-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.62);
    z-index: 98;
}

.divider {
    position: relative;
    height: 3px;
}

.divider:after {
    content: '';
    position: absolute;
    left: 0;
    opacity: 1;
    top: 0;
    width: 24px;
    height: 3px;
    border-radius: 2px;
    background: #ff3355;
}

.social-media-item {
    text-decoration: none;
    cursor: pointer;
}

.social-media-item i {
    color: #fff;
    font-size: 32px;
}

.footer a.social-media i {
    color: #666;
}

.footer a:hover.social-media i {
    color: #999;
}

.footer a.link {
    color: #666;
    text-decoration: none;
}

.footer a:hover.link {
    color: #999;
    text-decoration: none;
}

.copyright {
    color: #666;
}

@media (max-width: 991px) {
    .h1 {
        font-size: 24px;
    }
}

.tab-list {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.tab-item-choose {
    width: 33%;
    font-size: 30px;
    color: #000;
    text-align: center;
}

.tab-item-choose-mobile {
    width: 100%;
    font-size: 22px;
    color: #000;
    text-align: center;
}

.tab-item {
    width: 50%;
    font-size: 28px;
    color: #999;
    text-align: center;
}

.tab-item-mobile {
    width: 100%;
    font-size: 20px;
    color: #999;
    text-align: center;
}

.image-list {
    width: 16.5%;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
}

.image-list-mobile {
    width: 32%;
    margin-top: 10px;
    margin-left: 6px;
    margin-right: 6px;
}

.image-item-mobile {
    height: 30px;
    width: 85px;
    background-color: #fff;
}

.image-item {
    height: 67px;
    width: 245px;
    background-color: #fff;
}

.oracle-bg {
    width: 100%;
    color: #fff;
    height: 230px;
    position: relative;
}

.oracle-bg-min {
    width: 100%;
    color: #fff;
    height: 270px;
    position: relative;
}
</style>
